import { useState, useEffect } from "react";

const STORAGE_KEY = "dragons_cookie_consent_v1";

const NOTICE =
  "Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας στην ιστοσελίδα μας. Τα cookies μας βοηθούν να αναλύουμε την επισκεψιμότητα και να προσαρμόζουμε το περιεχόμενο στις ανάγκες σας. Συνεχίζοντας την περιήγηση, αποδέχεστε τη χρήση των cookies.";

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-stone-200/90 bg-[#f7f5f0]/95 px-4 py-3 shadow-[0_-4px_24px_rgba(0,0,0,0.06)] backdrop-blur-md md:px-8"
      role="dialog"
      aria-label="Ενημέρωση cookies"
      aria-live="polite"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
        <button
          type="button"
          onClick={accept}
          className="shrink-0 self-start rounded-md border border-stone-300 bg-white px-5 py-2.5 font-oswald text-xs font-semibold uppercase tracking-widest text-stone-800 shadow-sm transition-colors hover:border-dragons-red hover:bg-dragons-red hover:text-white sm:self-center"
        >
          Κατάλαβα
        </button>
        <p className="min-w-0 flex-1 font-manrope text-xs leading-relaxed text-stone-600 sm:text-sm sm:leading-snug">
          {NOTICE}
        </p>
      </div>
    </div>
  );
}
